import { render } from "./PR7-041322.vue?vue&type=template&id=3da4673c"
import script from "./PR7-041322.vue?vue&type=script&lang=js"
export * from "./PR7-041322.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__